import React from 'react';
import {QuestionTypeViewPropTypes} from '../../../shapes/index.mjs';
import QuestionText from '../../questions/QuestionText.jsx';
import classNames from 'classnames';
import {CheckboxRadio, CheckboxRadioGroup} from '@ignitesales/react-checkbox-radio';
import {getQuestionAnswerText, getQuestionAnswerTooltip} from '../../../util/questionUtil.jsx';
import ReactSVG from 'react-svg';
import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';
import {getMessageValue} from '../../../i18n/messageUtil.mjs';

const CheckboxRadioIcon = props => {
  const {className, valueChanged, question, value: {value = []} = {}, type} = props;
  const intl = useIntl();

  const {appkey, answers} = question;
  const cssBEM = 'checkboxRadioIcon';
  const attributes = question.attributes || {};

  const answerOptions = answers.map((option, index) => {
    const checkedValues = value;
    const isChecked = Array.isArray(checkedValues)
      ? checkedValues.indexOf(option.key) >= 0
      : checkedValues === option.key;
    const icon = getMessageValue(intl.locale, `${appkey}.${option.key}.icon`);
    const iconRender = attributes.cssIcons ? (
      <span className={`${cssBEM}__cssIcons ${icon}`} />
    ) : (
      <ReactSVG src={icon} />
    );
    const answerClasses = {
      btn: true,
    };
    const optionClasses = classNames(
      `${cssBEM}__option-container`,
      {[`${cssBEM}__option-container--checked`]: isChecked},
      option?.className
    );
    answerClasses[`${cssBEM}__option`] = true;
    answerClasses[`${cssBEM}__option--checked`] = Array.isArray(checkedValues)
      ? checkedValues.indexOf(option.key) >= 0
      : checkedValues === option.key;

    const handleKeyPress = event => {
      let checked = false;
      if (event.key === 'Enter' || event.key === ' ') {
        if (type === 'radio') {
          checked = true;
        } else {
          checked = !isChecked;
        }
        valueChanged(option.key, {checked});
      }
    };

    return (
      <div className={optionClasses} key={`${appkey}-${index}`}>
        <label
          className={classNames(answerClasses)}
          role={type}
          aria-checked={
            Array.isArray(checkedValues) ? checkedValues.indexOf(option.key) >= 0 : checkedValues === option.key
          }
          tabIndex="0"
          onKeyPress={handleKeyPress}
        >
          <CheckboxRadio value={option.key} />
          <div className={`${cssBEM}__label`}>
            <div className={`${cssBEM}__icon`}>{iconRender}</div>
            <span>{getQuestionAnswerText(appkey, option.key)}</span>
            {getQuestionAnswerTooltip(appkey, option.key, attributes)}
          </div>
        </label>
      </div>
    );
  });

  return (
    <div className={className} id={appkey}>
      <QuestionText question={question} />
      <CheckboxRadioGroup
        name={appkey}
        className={cssBEM}
        onChange={valueChanged}
        type={type}
        value={value}
      >
        <div className={`${cssBEM}__options`}>
          {answerOptions}
        </div>
      </CheckboxRadioGroup>
    </div>
  );
};

CheckboxRadioIcon.propTypes = {
  ...QuestionTypeViewPropTypes,
  type: PropTypes.oneOf(['radio', 'checkbox']),
};

export default CheckboxRadioIcon;
